import styled from 'styled-components';

export const MobilePickerWrapper = styled.label`
  display: flex;
  flex-direction: column;
  width: 100%;

  .CalendarMonth {
    &_caption {
      top: -25px;
      position: relative;
      padding-bottom: 0px;
    }
  }

  .DayPicker {
    border-radius: 20px 20px 0 0;
    padding-top: 66px;
    width: 100%;
    overflow: hidden;

    > div {
      border-top: 1px solid #eff0f1;
    }

    &_weekHeader {
      top: 60px;
    }
  }

  .CalendarMonthGrid_month__hidden {
    display: none;
  }

  .DayPicker__hidden {
    visibility: visible;
  }
  .DayPicker_transitionContainer__vertical {
    height: initial !important;
    padding-bottom: 40px;
  }
  .CalendarMonthGrid {
    width: 100% !important;
  }
`;
